import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChart2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chart-2, statistics, flipchart, presentation, graph"} maskId="square-filled-radius-0-stroke-1-IconChart2"><path fillRule="evenodd" clipRule="evenodd" d="M1 3H23V4H21V18H12.9343L14.6934 20.6387L13.8613 21.1934L12 18.4014L10.1387 21.1934L9.30663 20.6387L11.0657 18H3V4H1V3ZM12.5 7H11.5V14H12.5V7ZM17 9H16V14H17V9ZM8 11H7V14H8V11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChart2;
